import { render, staticRenderFns } from "./CRelationFieldView.vue?vue&type=template&id=022c5936&scoped=true&"
import script from "./CRelationFieldView.vue?vue&type=script&lang=js&"
export * from "./CRelationFieldView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c5936",
  null
  
)

export default component.exports